// @ts-nocheck
import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
import * as Types from "../../__generated__/schema.graphql.types";

const defaultOptions = {} as const;
export type MedspaCommunicationSettingsQueryVariables = Types.Exact<{
  medspaId: Types.Scalars["bigint"]["input"];
}>;

export type MedspaCommunicationSettingsQuery = {
  __typename?: "query_root";
  medspaByPk?: {
    __typename?: "medspa";
    id: string;
    name: string;
    configuration?: {
      __typename?: "MedspasMedspaconfiguration";
      sendConfirmationReminderSms: boolean;
      sendConfirmationReminderMail: boolean;
      bookingConfirmationMailAdditionalText: string;
      bookingConfirmationSmsAdditionalText: string;
      confirmationReminderAdvanceHours: number;
      confirmationReminderMailAdditionalText: string;
      confirmationReminderSmsAdditionalText: string;
      appointmentConfirmedSmsAdditionalText: string;
      followupNoteDelayHours: number;
      followupNoteMailAdditionalText: string;
      followupNoteSmsText: string;
      secondReminderAdvanceHours: number;
      secondReminderMailAdditionalText: string;
      secondReminderSmsAdditionalText: string;
      sendFollowupNoteSms: boolean;
      sendFollowupNoteMail: boolean;
      sendSecondReminderSms: boolean;
      sendSecondReminderMail: boolean;
      sendAfterAppointmentNoteSms: boolean;
      sendAfterAppointmentNoteMail: boolean;
      afterAppointmentMailAdditionalText: string;
      afterAppointmentSmsAdditionalText: string;
      sendCheckInReminderSms: boolean;
      sendCheckInReminderMail: boolean;
      checkInReminderAdvanceMinutes: number;
      sendAfterPaymentReceiptSms: boolean;
      sendAfterPaymentReceiptMail: boolean;
      afterPaymentReceiptMailAdditionalText: string;
      afterPaymentReceiptSmsAdditionalText: string;
      sendBookingConfirmationSms: boolean;
      sendBookingConfirmationMail: boolean;
    } | null;
  } | null;
};

export const MedspaCommunicationSettingsDocument = gql`
  query MedspaCommunicationSettings($medspaId: bigint!) {
    medspaByPk(id: $medspaId) {
      id
      name
      configuration {
        sendConfirmationReminderSms
        sendConfirmationReminderMail
        bookingConfirmationMailAdditionalText
        bookingConfirmationSmsAdditionalText
        confirmationReminderAdvanceHours
        confirmationReminderMailAdditionalText
        confirmationReminderSmsAdditionalText
        appointmentConfirmedSmsAdditionalText
        followupNoteDelayHours
        followupNoteMailAdditionalText
        followupNoteSmsText
        secondReminderAdvanceHours
        secondReminderMailAdditionalText
        secondReminderSmsAdditionalText
        sendFollowupNoteSms
        sendFollowupNoteMail
        sendSecondReminderSms
        sendSecondReminderMail
        sendAfterAppointmentNoteSms
        sendAfterAppointmentNoteMail
        afterAppointmentMailAdditionalText
        afterAppointmentSmsAdditionalText
        sendCheckInReminderSms
        sendCheckInReminderMail
        checkInReminderAdvanceMinutes
        sendAfterPaymentReceiptSms
        sendAfterPaymentReceiptMail
        afterPaymentReceiptMailAdditionalText
        afterPaymentReceiptSmsAdditionalText
        sendBookingConfirmationSms
        sendBookingConfirmationMail
      }
    }
  }
`;

/**
 * __useMedspaCommunicationSettingsQuery__
 *
 * To run a query within a React component, call `useMedspaCommunicationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedspaCommunicationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedspaCommunicationSettingsQuery({
 *   variables: {
 *      medspaId: // value for 'medspaId'
 *   },
 * });
 */
export function useMedspaCommunicationSettingsQuery(
  baseOptions: Apollo.QueryHookOptions<
    MedspaCommunicationSettingsQuery,
    MedspaCommunicationSettingsQueryVariables
  > &
    (
      | { variables: MedspaCommunicationSettingsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    MedspaCommunicationSettingsQuery,
    MedspaCommunicationSettingsQueryVariables
  >(MedspaCommunicationSettingsDocument, options);
}
export function useMedspaCommunicationSettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MedspaCommunicationSettingsQuery,
    MedspaCommunicationSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MedspaCommunicationSettingsQuery,
    MedspaCommunicationSettingsQueryVariables
  >(MedspaCommunicationSettingsDocument, options);
}
export function useMedspaCommunicationSettingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MedspaCommunicationSettingsQuery,
        MedspaCommunicationSettingsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    MedspaCommunicationSettingsQuery,
    MedspaCommunicationSettingsQueryVariables
  >(MedspaCommunicationSettingsDocument, options);
}
export type MedspaCommunicationSettingsQueryHookResult = ReturnType<
  typeof useMedspaCommunicationSettingsQuery
>;
export type MedspaCommunicationSettingsLazyQueryHookResult = ReturnType<
  typeof useMedspaCommunicationSettingsLazyQuery
>;
export type MedspaCommunicationSettingsSuspenseQueryHookResult = ReturnType<
  typeof useMedspaCommunicationSettingsSuspenseQuery
>;
export type MedspaCommunicationSettingsQueryResult = Apollo.QueryResult<
  MedspaCommunicationSettingsQuery,
  MedspaCommunicationSettingsQueryVariables
>;
